import React from 'react';

import Paths, { SVGPaths } from './Paths';

function getIconPath(name) {
  const iconPath = Paths.find(({ names }) => names.includes(name));
  if (!iconPath) {
    return SVGPaths.Directions;
  }
  return iconPath.path;
}

function TransportIcon({ width = 24, height = 24, name, ...rest }) {
  const path = getIconPath(name.toLowerCase());

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" {...rest}>
      <path d={path} />
    </svg>
  );
}

export default TransportIcon;
